import React from "react";
import { Route, Switch } from "react-router-dom";

import SamplePage from "./SamplePage";
import TestPage from "./TestPage";

function DevSanadBox(props: any) {
  let routeMatch = props.match;

  return (
    <div className="gx-main-content-wrapper">
      <Switch>
        <Route path={`${routeMatch.url}/sample`} component={SamplePage} />
        <Route path={`${routeMatch.url}/test`} component={TestPage} />
      </Switch>
    </div>
  );
}

export default DevSanadBox;
